import { CSSProperties, FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { DEFAULT_EMPTY_VALUE_PLACEHOLDER, DEFAULT_TAG_STYLES } from 'configs/common';
import { IAssignedDriverTagProps } from './types';
import { Tag, Tooltip } from 'antd';
import { CarOutlined } from '@ant-design/icons';

const TAG_STYLES: CSSProperties = {
	...DEFAULT_TAG_STYLES,
	borderRadius: '12px',
	textTransform: 'capitalize',
};

export const AssignedDriverTag: FC<IAssignedDriverTagProps> = memo(({ driverName }) => {
	const { t: tCommon } = useTranslation('common');

	// ! render
	return (
		<Tooltip title={tCommon(driverName ? 'driver.assigned' : 'driver.unassigned')}>
			<Tag
				color='geekblue'
				icon={<CarOutlined />}
				style={TAG_STYLES}
			>
				{driverName ?? DEFAULT_EMPTY_VALUE_PLACEHOLDER}
			</Tag>
		</Tooltip>
	);
});
